import { render, staticRenderFns } from "./ChallengesCommercials.vue?vue&type=template&id=33eb3884&"
import script from "./ChallengesCommercials.vue?vue&type=script&lang=js&"
export * from "./ChallengesCommercials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports